import ModuleLazyLoaderService from '../module-lazy-loader'

const stringTable = {
    accountManagementTitle: 'Organization Management',
    clientSearchHeading: 'Select a client',
    dataManagementTitle: 'Data Management',
    deepLinkKey: 'deepLink',
    forbiddenRoute: '/403',
    loginRoute: '/',
    logoutLabel: 'Logout',
    logoutRoute: '/logout',
    pageTitleDefault: 'GSM Portal',
    pageTitlePattern: 'GSM - %s',
    serverErrorRoute: '/500',
    userManagementTitle: 'User Management',
    workspaceKey: 'workspace',
    authenticationErrorTitle: 'Login Failed',
    authenticationErrorMessage: 'Your login attempt has failed. Please try again. ' +
        'If you continue to have login issues then please contact customer support.',
        redirNoMatch : "It looks like you are navigating from an account isn't available in Lifecycle. Please choose another dealership account. Need help? Click “Yes” and your Account Representative will reach out.", 
        noDest : "It looks like your dealership isn't set up for Lifecycle yet. Engage your customers throughout their service journey with Lifecycle, a robust, loyalty program designed to boost loyalty and retention. By utilizing your DMS data, Lifecycle automates daily communications to eligible customers, providing timely and targeted offers tailored to each customer's specific service needs. With its triggered messaging, you can ensure the right offer is delivered at the right price to the right customer—keeping your business front of mind and improving service retention. Our dedicated Customer Success Manager will contact you to guide you through the process of activating and customizing Lifecycle Service Retention for your dealership!\n<br><p style='text-align: center; margin-top: 12px;'>or</p>\nIf you have already signed up for Lifecycle, we are actively working on your access",
        redirNoAuth :  "Your account is not authorized to under the dealer you were viewing on the previous platform. You will be taken to ",
}

const stringTableKeys = (() => {
    const keys = {}
    Object.keys(stringTable).forEach((key) => {
        keys[key] = key
    })
    return keys
})()

export default class StringTableService {

    static keys = stringTableKeys

    static getString(key) {
        if (!(key in stringTable)) {
            /* eslint-disable no-console */
            console.log(`StringTableService does not have key '${key}'`)
            /* eslint-enable no-console */
        }
        return stringTable[key] || ''
    }

    // subsequent parameters will be applied to the
    // sprintf pattern as specified by the patternKey
    static lazyFormatString(patternKey) {

        const args = Array.from(arguments)
        args.shift()

        return ModuleLazyLoaderService.load('format')
            .then((modules) => {
                const format = modules['format']
                const pattern = this.getString(patternKey)
                try {
                    return format.vsprintf(pattern, args)
                }
                catch (error) {
                    /* eslint-disable no-console */
                    console.log('StringTableService failed to format string')
                    console.log(error.stack)
                    /* eslint-enable no-console */
                    return ''
                }
            })

    }

}



// WEBPACK FOOTER //
// src/services/string-table/index.js